// PocketBase sync disabled — using Cloudflare Worker + PIN login instead
export const syncManager = {
    getPublicPlaylist: async () => null,
    syncUserFolder: async () => {},
    publishPlaylist: async () => {},
    unpublishPlaylist: async () => {},
    syncUserPlaylist: async () => {},
    onAuthStateChanged: () => {},
};
